// Lets the bottom bar move the map without owning its state
export const focusOnMap = (name, cities = [], open = true) => {
  document.getElementById("travel")?.scrollIntoView({ behavior: "smooth" });
  window.dispatchEvent(new CustomEvent("bl:focus", { detail: { name, cities, open } }));
};

export const locateMe = (fresh = false) =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("Your browser can't share location"));
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lon: p.coords.longitude }),
      (e) => reject(new Error(e.code === 1 ? "Location permission was blocked — allow it in your browser settings" : "Couldn't find your location")),
      { enableHighAccuracy: false, timeout: 15000, maximumAge: fresh ? 0 : 10 * 60 * 1000 }
    );
  });
